"use client"
import { Box, Typography, Button, Paper } from "@mui/material"
import { Lock as LockIcon } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { useTheme } from "@mui/material/styles"
import { tokens } from "../theme"

const AccessDenied = () => {
  const navigate = useNavigate()
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)

  const handleReturn = () => {
    navigate("/")
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        p: 2,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 4,
          maxWidth: 600,
          textAlign: "center",
          borderRadius: 3,
          backgroundColor: theme.palette.background.paper,
          border: `2px solid ${colors.primary[200]}`,
          boxShadow: `0 20px 60px rgba(34, 197, 94, 0.15)`,
          animation: "slideUp 0.6s ease-out",
          "@keyframes slideUp": {
            from: { opacity: 0, transform: "translateY(30px)" },
            to: { opacity: 1, transform: "translateY(0)" },
          },
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
          <Box
            sx={{
              p: 2,
              borderRadius: "50%",
              backgroundColor: colors.primary[600],
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LockIcon sx={{ fontSize: 80, color: "white" }} />
          </Box>

          <Typography variant="h4" color="text.primary" fontWeight="bold" sx={{ letterSpacing: "-0.5px" }}>
            Accès Refusé
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
            Désolé, vous n'avez pas l'autorisation de consulter cette page. Veuillez vérifier vos droits d'accès ou
            contactez l'administrateur.
          </Typography>

          <Button
            onClick={handleReturn}
            variant="contained"
            size="large"
            sx={{
              backgroundColor: colors.primary[600],
              color: "white",
              mt: 2,
              px: 4,
              py: 1.5,
              borderRadius: 2,
              fontWeight: "bold",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: colors.primary[700],
                transform: "translateY(-2px)",
                boxShadow: `0 10px 25px rgba(34, 197, 94, 0.3)`,
              },
            }}
          >
            Retour à l'accueil
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}

export default AccessDenied
